// const SysSet={
//   LoginType:'threeLogin'//system表示系统自带登录，threeLogin表示第三方登录
// }
const SysSet={
  LoginType:'system',//system表示系统自带登录，threeLogin表示第三方登录
  //tyrzUrl:'http://111.12.155.39:9088/am/oauth2/authorize?service=initService&client_id=mzgzfwpt&response_type=code&scope=all&redirect_uri=https://www.jujiaservice.com/jjkj/ywt_home/index_auth.html',
  //tyrzReturnUrl:'https://www.jujiaservice.com/jjkj/ywt_home/index_auth.html',
  //tyrzLogoutReturnUrl:'https://www.jujiaservice.com/jjkj/ywt_home',//返回首页地址
  tyrzUrl:'https://uams.qhzwfw.gov.cn/am/oauth2/authorize?service=initService&client_id=mzgzfwpt&response_type=code&scope=all&redirect_uri=https://mzt.qinghai.gov.cn/qmtb/ywt_home/index_auth.html',
  tyrzReturnUrl:'https://mzt.qinghai.gov.cn/qmtb/ywt_home/index_auth.html',
  tyrzLogoutReturnUrl:'https://mzt.qinghai.gov.cn/qmtb/ywt_home',//返回首页地址
}
const TaskStates= {
    un_allot:0,     //调研待分配
    un_survey:5,    //待调研
    surveying:10,   //调研中
    surveyed:15,    //调研已完成
    aid_plan_make:16,    //帮扶方案已编制
    aid_plan_audit:17,    //帮扶方案待审核
    aid_plan_pass:18,    //帮扶方案已通过
    un_allot_revisit:20,  //回访待分配
    un_revisit:25,        //待回访
    revisited:30,         //已回访
    delay:97,     //改期
    refuse:98     //拒绝
  };

const baseState={
  ToSurvey:'10',
  Surveying:'20',
  Done:'99'
};

const ResponseCode={
  success:200,
  error:400
};

const NewsCode={
  guide:100,
  policies:200,
  news:300,
  notice:400,
  aidNews:500
};
const archiveTypeCode={
  BLAN:{code:"BLAN",name:"城乡低保"},
  CLP_LIV:{code:"CLP_LIV",name:"残疾人生活补贴"},
  CLP_HLF:{code:"CLP_HLF",name:"残疾人护理补贴"},
  NTF:{code:"NTF",name:"特困供养"},
  TEMP:{code:"TEMP",name:"临时救助"},
  BLAN_ORP:{code:"BLAN_ORP",name:"事实无人抚养儿童"},
  ORP:{code:"ORP",name:"孤儿"},
  POC:{code:"POC",name:"困境儿童"},
  OLD:{code:"OLD",name:"高龄津贴"},
  SPEC_ORP:{code:"SPEC_ORP",name:"SPEC_ORP"}
}
const archiveTypeCodeName={
  BLAN:{"BLAN":"城乡低保"},
  CLP_LIV:{"CLP_LIV":"残疾人生活补贴"},
  CLP_HLF:{"CLP_HLF":"残疾人护理补贴"},
  NTF:{"NTF":"特困供养"},
  TEMP:{"TEMP":"临时救助"},
  BLAN_ORP:{"BLAN_ORP":"事实无人抚养儿童"},
  ORP:{"ORP":"孤儿"},
  POC:{"POC":"困境儿童"},
  OLD:{"OLD":"高龄津贴"}
}
export default {TaskStates,ResponseCode,NewsCode,baseState,archiveTypeCode,archiveTypeCodeName,SysSet};



// WEBPACK FOOTER //
// ./src/consts.js